import { useEffect } from "react";

import { Typography, Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setAllEmployees } from "../../redux/actions/mainAction";

const EmployeesForHome = () => {
  const { MainResponse } = useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    getEmployees();
  }, []);

  const getEmployees = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/get-employees/?page=${1}`,
        {
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      const result = await response.json();
      dispatch(setAllEmployees(result.employees));
    } catch (error) {
      console.log(error);
    }
  };

  const emptyEmployees = () => (
    <div>
      <Row>
        <Col span={24}>
          <Typography.Text className="title-employee">
            İstifadəçi tapılmadı
          </Typography.Text>
        </Col>
      </Row>
    </div>
  );

  const renderEmployees = (employee) => (
    <div
      key={employee._id}
      style={{ flex: "0 0 19.5%" }}
      className="employee-container"
    >
      <Row>
        <Col span={24}>
          <Typography.Text className="title-employee">
            {employee.employeeName}
          </Typography.Text>
        </Col>
      </Row>
    </div>
  );

  var visibleEmployees =
    MainResponse.allEmployees.length > 0
      ? MainResponse.allEmployees.slice(0, 15)
      : null; // Limit to 6 items

  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {MainResponse.allEmployees.length > 0
        ? visibleEmployees.map((employee) => renderEmployees(employee))
        : emptyEmployees()}
    </div>
  );
};

export default EmployeesForHome;
